import {useMutation} from '@tanstack/react-query';
import {GetRefundSpecialtiesParams} from 'domain/usecases';
import {getRefundSpecialties} from '../../services/getRefundSpecialties';

export const useGetRefundSpecialtiesMutation = () =>
	useMutation({
		mutationFn: (params: GetRefundSpecialtiesParams) => getRefundSpecialties(params),
	});
